<template>
  <div style="width: 100%;">
    <div class="brdr-cl-primary pb60">
      <div class="pt10 serif cl-accent container">
        <div class="row shipping-row h5 align-left cl-accent " >
          <div class="col-xs-5 brdr-right-1 brdr-cl-bg-secondary">
            {{ $t('Name') }}
          </div>
          <div class="col-xs-7 " >
            {{ userInfo.firstName + ' ' + userInfo.lastName }}
          </div>
        </div>
        <div class="row shipping-row h5 align-left cl-accent">
          <div class="col-xs-5  brdr-right-1 brdr-cl-bg-secondary">
            {{ $t('E-mail') }}
          </div>
          <div class="col-xs-7" >
            {{ userInfo.emailAddress }}
          </div>
        </div>
        <div class="row  shipping-row h5 align-left cl-accent">
          <div class="col-xs-5 brdr-right-1 brdr-cl-bg-secondary">
            {{ $t('Phone number') }}
          </div>
          <div class="col-xs-6" >
            {{ userInfo.phone_number }}
          </div>
        </div>
        <div class="row shipping-row align-left cl-accent h5">
          <div class="col-xs-5 brdr-right-1 brdr-cl-bg-secondary">
            {{ $t('Courier pickup address') }}
          </div>
          <div class="col-xs-7" >
            {{ assemblePickupAddress }}
          </div>
        </div>
        <div class="row shipping-row align-left cl-accent h5">
          <div class="col-xs-5 brdr-right-1 brdr-cl-bg-secondary">
            {{ $t('Delivery Address') }}
          </div>
          <div class="col-xs-7" >
            {{ assembleAddress }}
          </div>
        </div>
        <div class="row shipping-row align-left cl-accent  h5">
          <div class="col-xs-5 brdr-right-1 brdr-cl-bg-secondary">
            {{ $t('Delivery Time') }}
          </div>
          <div class="col-xs-7" >
              {{ $t(deliveryTime.asap ? 'ASAP' : deliveryTime.datetime) }}
            </div>
        </div>
        <div class="row shipping-row h5 align-left cl-accent ">
          <div class="col-xs-5 brdr-right-1 brdr-cl-bg-secondary">
            {{ $t('Payment Method') }}
          </div>
          <div class="col-xs-7" >
              {{ $t(payment.title) }}
          </div>
        </div>
        <div class="row shipping-row h5 cl-accent align-left">
          <div class="col-xs-5 brdr-right-1 brdr-cl-bg-secondary">
            {{ $t('Ordered') }}
          </div>
          <div class="col-xs-7 pre-line" >
            {{ pickupTarget }}
          </div>
        </div>
        <div class="row shipping-row h5 cl-accent align-left">
          <div class="col-xs-5 brdr-right-1 brdr-cl-bg-secondary">
            {{ $t('Delivery') }}
          </div>
          <div class="col-xs-7" >
            {{ deliveryPrice == null ? '—' : `${deliveryPrice} ${$t('UAH')}` }}
          </div>
        </div>
        <div class="row weight-400 h3 align-left py10 mt10 bg-cl-secondary" style="font-weight: bold;">
          <div class="col-xs-5">
            {{ $t('Total') }}
          </div>
          <div class="col-xs-7 align-left cl-accent">
            {{ deliveryPrice == null ? '—' : deliveryPrice.toFixed(2) + ' ' + $t('UAH') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PickupSummary',
  props: {
    userInfo: {
      type: Object,
      required: true
    },
    shipping: {
      type: Object,
      required: false
    },
    pickupAddress: {
      type: Object,
      required: false
    },
    pickupTarget: {
      type: String,
      required: false
    },
    deliveryTime: {
      type: Object,
      required: false
    },
    payment: {
      type: Object,
      required: false
    },
    deliveryPrice: {
      type: Number,
      default: null
    }
  },
  computed: {
    assembleAddress () {
      let address = `${this.shipping.street}, ${this.shipping.house}`
      if (this.shipping.apartment) {
        address += `, ${this.$t('кв. ')}${this.shipping.apartment}`
      }
      return address
    },
    assemblePickupAddress () {
      if (!this.pickupAddress) return ''
      let address = `${this.pickupAddress.street}, ${this.pickupAddress.house}`
      if (this.pickupAddress.apartment) {
        address += `, ${this.$t('кв. ')}${this.pickupAddress.apartment}`
      }
      return address
    }
  }
}
</script>

<style lang="scss" scoped>
  .shipping-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    .shipping-row-child {
      color: green;
      text-align:right;
    }
  }
  .pre-line {
    white-space: pre-line;
    margin-top: -1em;
    word-wrap: break-word;
  }
  .summary-title {
    @media (max-width: 768px) {
      margin-left: 0;
    }
  }
  .loading__wrapper {
    svg {
      margin: 0 auto;
    }
  }
  .loader__text {
    span {
      margin: 0 auto;
    }
  }
</style>
